// extracted by mini-css-extract-plugin
module.exports = {"screenshot":"Screenshot_screenshot__qOElo"};